export const OFFER_PARAM = 'offer';
export const QUOTES_PROMO_PARAM_VALUE = 'quotes-promo';
